var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"small mb-0"},[_vm._v(" Deposit into "+_vm._s(_vm.transaction.walletShare.description)+" via Stripe ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }